import { Divider } from '@mui/material';
import { PencilSimple, Plus } from '@phosphor-icons/react';
import { useTranslation } from 'react-i18next';
import { Swiper } from 'swiper/react';
import { Pagination } from 'swiper';

import { Accordion, Button, Spacer } from 'theSource/components';
import {
  ActionsStyled,
  ActionsWrapperStyled,
  SwiperWrapperStyled,
  BeneficiariesSectionStyled,
} from './BeneficiariesStyled';
import { BeneficiarySlide } from './components';
import { BeneficiariesProps } from './types';
import 'swiper/css';
import 'swiper/css/pagination';

export const Beneficiaries = ({ beneficiaries = [] }: BeneficiariesProps) => {
  const primaryBeneficiaries = beneficiaries?.filter(
    (person) => person.isPrimary
  );
  const secondaryBeneficiaries = beneficiaries?.filter(
    (person) => !person.isPrimary
  );

  const { t } = useTranslation('pages.benefits');

  return (
    <>
      {beneficiaries.length > 0 && (
        <BeneficiariesSectionStyled>
          <h2 className="headline-3">{t('beneficiaries')}</h2>
          <Spacer height={4} />
          <Accordion
            label={t('myBeneficiaries')}
            testId="beneficiaries-accordion"
          >
            <SwiperWrapperStyled>
              <Swiper
                spaceBetween={30}
                pagination={{
                  clickable: true,
                }}
                modules={[Pagination]}
              >
                <BeneficiarySlide
                  title={t('primaryBeneficiaries')}
                  beneficiaries={primaryBeneficiaries}
                  fallbackMessage={t('noPrimaryBeneficiaries')}
                  itemTestId="primary-beneficiary"
                />
                <BeneficiarySlide
                  title={t('secondaryBeneficiaries')}
                  beneficiaries={secondaryBeneficiaries}
                  fallbackMessage={t('noSecondaryBeneficiaries')}
                  itemTestId="secondary-beneficiary"
                />
                <Divider />
              </Swiper>
            </SwiperWrapperStyled>
            <ActionsWrapperStyled hidden>
              <ActionsStyled>
                <Button
                  fullWidth
                  data-testid="edit-button"
                  startIcon={<PencilSimple size={20} weight="duotone" />}
                  label={t('edit')}
                  variant="tertiary"
                  type="button"
                  onClick={() => alert('TODO: onEdit(..)')}
                />
                <Spacer width={6} />
                <Button
                  fullWidth
                  data-testid="add-button"
                  startIcon={<Plus size={16} weight="bold" />}
                  label={t('add')}
                  variant="primary"
                  type="button"
                  onClick={() => alert('TODO: onAdd(..)')}
                />
              </ActionsStyled>
            </ActionsWrapperStyled>
          </Accordion>
        </BeneficiariesSectionStyled>
      )}
    </>
  );
};
